import React, { useState } from 'react'
import AuthLayout from '../layout/AuthLayout'
import RightPanelTopMenu from '../component/molecule/common/RightPanelTopMenu'

import style from '../assets/styles/testCreationStyle.module.css'
import TestList from '../component/molecule/specific/TestCreationScreens/TestList'
import AddTest from '../component/molecule/specific/TestCreationScreens/AddTest'
import EditTest from '../component/molecule/specific/TestCreationScreens/EditTest'
import TestDetails from '../component/molecule/specific/TestCreationScreens/TestDetails'
import { useSelector } from 'react-redux'

const TestCreation = () => {


  const { testScreen } = useSelector((state) => state.GetAllData);
  const [limit, setLimit] = useState(50)
  const [offset, setOffset] = useState(0)
  return (
    <AuthLayout>
      <RightPanelTopMenu title={"Test Templates and Test Papers"} />
      <div className={style.mainScreen}>

        {testScreen === 0 ? <TestList limit={limit} offset={offset} setOffset={setOffset}/> : ""}
        {testScreen === 1 ? <AddTest limit={limit} offset={offset}/> : ""}
        {testScreen === 2 ? <TestDetails limit={limit} offset={offset}/> : ""}
        {testScreen === 3 ? <EditTest limit={limit} offset={offset}/> : ""}

      </div>
    </AuthLayout>
  )
}

export default TestCreation